import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '1', label: 'Autorização' },
			{ value: '2', label: 'Correção' },
			{ value: '3', label: 'Cancelamento' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

